import TagManager from 'react-gtm-module'

export const useTracking = () => {
  return ({ event, parameter, value }: any) => {
    const objData = {
      ...(value
        ? { value: Array.isArray(value) ? value.join(',') : value }
        : {}),
      ...(parameter ? { parameter } : {}),
    }

    TagManager.dataLayer({
      dataLayer: {
        event: `e_${event}`,
        ...objData,
      },
    })

    if (typeof window?.Native?.genericEvent === 'function') {
      window.Native.genericEvent(`e_${event}`, objData)
    }
  }
}

export default useTracking

declare const window: any
